import plumGif from "../../../../src/images/plum-landing-eat.gif";
import * as React from 'react';
export default {
  plumGif,
  React
};